import React from 'react';
import { MinusCircle } from 'lucide-react';

const painPointsData = [
  "Land Holdings (Avg 2.5 acres per farmer)",
  "Low Quality production",
  "Unstructured Conventional Farming",
  "High Risk of Disease Attack",
  "Lack in Technology",
  "Cyclone / Nature Disaster"
];

const PainPoints = () => {
  // Shared accent color and dark green for consistency
  const accentColor = "#Cca32a"; 
  const darkGreen = "#1a4d2e";

  return (
    <section className="painpoints-section">
      <div className="painpoints-container">
        
        {/* Main Header Title (Consistent Style) */}
        <div className="mv-header">
          <h2 className="mv-title">Key Challenges in Agriculture</h2>
          <div className="mv-underline" style={{backgroundColor: accentColor}}></div>
        </div>

        <div className="painpoints-grid">
          {painPointsData.map((point, index) => (
            <div key={index} className="painpoint-card">
              <div className="painpoint-icon-box">
                {/* Using a red minus icon to signify 'pain' or negative point */}
                <MinusCircle size={24} color="#ef4444" strokeWidth={2} /> 
              </div>
              <p className="painpoint-text">{point}</p>
            </div>
          ))}
        </div>
        
        {/* Optional: Add a brief descriptive paragraph for context */}
        <p className="context-text">
          These are the critical challenges faced by small and marginal farmers in the current agricultural landscape that GK Agro Machinery aims to address through innovative and cost-effective solutions.
        </p>

      </div>

      <style>{`
        /* General Setup - Consistent with other sections */
        .painpoints-section {
          background-color: #f9fafb; /* Light background for contrast */
          padding: 4rem 1.5rem;
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
        }
        .painpoints-container {
          max-width: 1000px;
          margin: 0 auto;
        }

        /* Reused Header Styles */
        .mv-header {
          text-align: center;
          margin-bottom: 3.5rem;
        }
        .mv-title {
          font-size: 2.5rem;
          color: ${darkGreen}; /* Dark Forest Green */
          margin-bottom: 0.5rem;
          font-weight: 600;
        }
        .mv-underline {
          width: 80px;
          height: 4px;
          margin: 0 auto;
          border-radius: 2px;
        }
        
        /* Grid Layout for Pain Points */
        .painpoints-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
          gap: 1.5rem;
          margin-bottom: 3rem;
        }

        /* Individual Card Styling */
        .painpoint-card {
          display: flex;
          align-items: center;
          background: #ffffff;
          padding: 1.5rem;
          border-radius: 10px;
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
          border: 1px solid #e5e7eb;
          transition: transform 0.2s ease;
        }
        
        .painpoint-card:hover {
            transform: translateY(-3px);
            box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
        }

        .painpoint-icon-box {
          flex-shrink: 0;
          margin-right: 1rem;
          display: flex;
          align-items: center;
        }

        .painpoint-text {
          font-size: 1rem;
          color: #1f2937; /* Dark text */
          font-weight: 500;
          margin: 0;
        }

        /* Context Text Styling */
        .context-text {
            text-align: center;
            max-width: 800px;
            margin: 0 auto;
            font-size: 1.05rem;
            color: #6b7280;
            line-height: 1.6;
            border-top: 1px dashed #d1d5db;
            padding-top: 2rem;
        }
      `}</style>
    </section>
  );
};

export default PainPoints;